import { ReactComponent as NoResultsIcon } from 'assets/icons/no_results.svg'

export const NoResult = () => {
  return (
    <div className="mx-auto basis-full flex justify-center items-center flex-col mt-20">
      <NoResultsIcon className="mx-auto" />
      <p className="mt-4 subtitle-s color-neutral-100 leading-6">No results for this search</p>
      <p className="body-s color-neutral-80 leading-6">
        There are no results for this search, try another one or use different filters.
      </p>
    </div>
  )
}
